export enum RecoilAtomKeys {
    OKTA_USER_ID_TOKEN = 'okta/userIdToken',
    GENESISES_USER_PARMAS = 'genesisEs/userParams',
    GENESISES_DASHBOARD_PARMAS = 'genesisEs/dashBoardParams',
    GENESISES_OPENLIST_PARMAS = 'genesisEs/openListParams',
    GENESISES_CLOSELIST_PARMAS = 'genesisEs/closeListParams',
}

export enum RecoilSelectorKeys {

}